import React, { useContext, useState } from "react";

import { MagnetIcon } from "fond/svg_icons";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const SnappingButton: React.FC<IButtonProps> = ({ icon, title, ...rest }) => {
  const { drawControl, map } = useContext(MapContext);
  const [snap, setSnap] = useState(drawControl.current?.options?.snap || false);

  const handleOnChange = () => {
    // Always read the current value from drawControl to avoid stale state
    const currentValue = !!drawControl.current?.options?.snap;
    const newValue = !currentValue;

    setSnap(newValue);

    // Fire event to notify DrawHandler to update options
    map?.fire("draw.options_changed", { snap: newValue });
  };

  return (
    <ToolbarToggleButton
      title={title || `${snap ? "Disable" : "Enable"} snapping`}
      {...rest}
      value="snap"
      onChange={handleOnChange}
      selected={snap}
      data-testid="toolbar-snap-button"
    >
      {icon || <MagnetIcon />}
    </ToolbarToggleButton>
  );
};

export default SnappingButton;
